import cliente from './cliente'
import empresa from './empresa'
import funcionalidade from './funcionalidade'
import modulo from './modulo'
import notaVersao from './nota-versao'
import ramoAtividade from './ramo-atividade'
import sistema from './sistema'
import usuario from './usuario'

export default [
    {
        meta: {authenticated: true, layout: 'admin'},
        path: '/cadastro',
        component: () => import('@/views/cadastro/Index'),
        children: [
            ...cliente,
            ...empresa,
            ...funcionalidade,
            ...modulo,
            ...notaVersao,
            ...ramoAtividade,
            ...sistema,
            ...usuario,
        ],
    },
]